import * as _ from 'lodash';
import { Document } from './document.model';
import { DocumentService } from './document.service';
import { Injectable } from '@angular/core';
import { ModelStore } from '../../../shared/stores/model.store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class DocumentStore extends ModelStore<Document> {

    constructor(private documentService: DocumentService) {
        super(documentService);
    }

    loadDocumentsForBorrower(borrowerId: number): Observable<number[]> {
        return this.documentService.documentsForBorrower(borrowerId).pipe(
            map((documents: Document[]) => {
                _.each(documents, (document) => this.inject(document));
                return _.map(documents, (document) => document.id);
            })
        );
    }
}
